const ITEMS = ["CAMPO & CONCRETO", "FUTEBOL", "RETRÔ", "BASQUETE"];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee-strip"
            className="relative border-y border-[#27272A] bg-[#0B0B0B] py-4 overflow-hidden"
        >
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((text, i) => (
                            <span key={i} className="flex items-center">
                                <span className="font-condensed font-bold uppercase tracking-[0.25em] text-sm text-[#A1A1AA] px-6">
                                    {text}
                                </span>
                                <span className="h-1.5 w-1.5 bg-[#FF6A00]" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
